'use client'

import { useRegisterUser } from '@/hooks/use-register-user'

export function UserRegistration() {
	useRegisterUser()
	return null
}
